var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(100%, 100%, 100%)",
    fillOpacity: 1,
    d: "M 4.617188 5.628906 C 4.339844 5.753906 4.175781 6.023438 4.175781 6.347656 C 4.175781 6.550781 4.25 6.753906 4.386719 6.898438 L 7.4375 10.183594 C 7.746094 10.519531 8.253906 10.519531 8.5625 10.183594 L 11.613281 6.898438 C 11.75 6.753906 11.824219 6.550781 11.824219 6.347656 C 11.824219 6.023438 11.660156 5.753906 11.382812 5.628906 C 11.109375 5.503906 10.816406 5.566406 10.605469 5.792969 L 8.289062 8.289062 C 8.128906 8.460938 7.871094 8.460938 7.710938 8.289062 L 5.394531 5.792969 C 5.183594 5.566406 4.890625 5.503906 4.617188 5.628906 Z M 4.617188 5.628906 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterArrow);
export default __webpack_public_path__ + "static/media/filter_arrow.683cc3a44686b183bec56eabd0f9c709.svg";
export { ForwardRef as ReactComponent };